import { useMediaQuery, useTheme } from '@mui/material'

import { MobileSettings } from './mobile.component'

import { DesktopSettings } from './desktop.component'
import { useSettings } from 'src/hooks'

export const AppSettings = () => {
  const theme = useTheme()
  const isTablet = useMediaQuery(theme.breakpoints.down('tablet'))
  const { data: settings, isFetching, isLoading } = useSettings()

  if (isTablet) {
    return (
      <MobileSettings
        settings={settings || null}
        isSettingsFetching={isFetching}
        isSettingsLoading={isLoading}
      />
    )
  }

  return (
    <DesktopSettings
      settings={settings || null}
      isSettingsFetching={isFetching}
      isSettingsLoading={isLoading}
    />
  )
}
